import type { CompanyGroupFormSchemaValues } from "../schemas/company-group-form.schema";

export const COMPANY_GROUP_FORM_DEFAULT_VALUES: CompanyGroupFormSchemaValues = {
  name: "",
  companies: [],
  description: undefined,
  updatedAt: undefined,
};
